import nl from "./translations/nl.json";

// English is the default message in each of our source files, so no need for a separate en.json file
const en = {};

export default { en, nl } as { [index: string]: Record<string, string> };
